const t=t=>t&&t.trim().split(" ").length>1||!1;export{t as fullNameMask};
